import { render, staticRenderFns } from "./PaxItem.vue?vue&type=template&id=23b54a52&"
import script from "./PaxItem.vue?vue&type=script&lang=ts&"
export * from "./PaxItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports